// Source: https://www.mandarinoriental.com.cn/zh-cn/fans-of-mo/benefits-enrolment
// Public fomo-benefits section, captured 2026-09-21. Keep the official wording.
import fan from './assets/fan.jpg';
import silk from './assets/silk.jpg';
import pearl from './assets/pearl.jpg';
import welcome from './assets/welcome.jpg';
import breakfast from './assets/breakfast.jpg';
import early from './assets/early.jpg';
import late from './assets/late.jpg';
import dining from './assets/dining.jpg';
import celebration from './assets/celebration.jpg';
import breakfastForTwo from './assets/breakfast-for-two.jpg';
import upgrade from './assets/upgrade.jpg';
import partners from './assets/partners.jpg';
import homes from './assets/homes.jpg';
import alliance from './assets/alliance.jpg';
import shop from './assets/shop.jpg';
import chef from './assets/chef.jpg';
import spa from './assets/spa.jpg';

export const PAGE_TITLE = '尚扇荟 (Fans of M.O.)会员礼遇';

export const introduction = [
  '尚扇荟 (Fans of M.O.) 的灵感源自亚洲历史上用于制作扇子的传统材料，完全体现文华东方的文化传承以及经典优雅魅力。',
  '随着您与文华东方的情谊渐深，我们还将邀请您加入会员社群，获享更多礼遇。'
];

const welcomeGift = {
  id: 'welcome', name: '礼遇相随', image: welcome,
  alt: 'Welcome gift being presented to a guest.',
  description: '获赠当地特色迎宾礼品。'
};
const earlyCheckIn = {
  id: 'early', name: '提前入住*', image: early,
  alt: 'Luxury daybed with a view of the water.',
  description: '顺畅抵店，提早安顿。'
};
const lateCheckOut = {
  id: 'late', name: '延迟退房*', image: late,
  alt: 'Woman sleeping in bed with an eye mask.',
  description: '离店日灵活退房，尽享每分美妙时光。'
};
const celebratoryTreat = {
  id: 'celebration', name: '纪念礼', image: celebration,
  alt: 'Children enjoying ice cream in front of a wall of flowers.',
  description: '我们可为您的重要时刻锦上添花。'
};
const diningCredit = (amount) => ({
  id: 'credit', name: `${amount}美元水疗或餐饮美食签账额`, image: dining,
  alt: 'Sauce being poured over a plate of food.',
  description: '体验我们的餐厅或享受我们的特色健康护理项'
});

export const partnerBenefits = [
  {
    id: 'partners', name: '合作伙伴专属活动', image: partners,
    alt: '文华东方酒店门前携购物袋的女士。',
    description: '尚扇荟尚扇会员可享受我们精选合作伙伴提供的专属附赠项目和优惠。'
  },
  {
    id: 'homes', name: '文华东方私享宅邸', image: homes,
    alt: '文华东方非凡府邸·意大利马塞里亚皮斯托拉庄园。',
    description: '酒店为您臻选一系列全球享誉的私人别墅、宅邸及住所，缔造奢华体验。此体验为尚扇荟尚扇会员专享，每次预订可尊享300欧元礼宾部签账额。',
    highlight: '每次预订可尊享300欧元礼宾部签账额'
  },
  {
    id: 'alliance', name: 'O&MO 联盟', image: alliance,
    alt: '毛里求斯欧贝罗伊酒店外的日落景观。',
    description: '邀您通过 O&MO 联盟，探索文华东方酒店与欧贝罗伊酒店及度假村两家获奖奢华酒店集团的独特文化。'
  },
  {
    id: 'shop', name: 'Shop MO 会员价', image: shop,
    alt: '浴室悬挂的浴袍。',
    description: '亲身体验文华东方酒店的魅力。尚扇荟尚扇会员可享专属的 ShopMO 九折会员折扣。',
    highlight: ' ShopMO 九折会员折扣'
  }
];

export const silkExperiences = [
  {
    id: 'chef', name: '主厨专献', image: chef,
    description: '尚扇荟缎扇会员在酒店餐厅用餐时，我们的主厨将会准备定制惊喜，诚邀会员体验。'
  },
  {
    id: 'spa', name: '水疗护理升级', image: spa,
    description: '贵为尊贵的缎扇会员，您可享受随水疗护理提供的免费附赠项目，尽情体验各种奢华产品和专业手法。'
  }
];

export const tiers = [
  {
    id: 'fans-of-mo', label: '尚扇荟 (Fans of M.O.)', name: '尚扇荟 (Fans of M.O.)',
    introduction: ['加入尚扇荟仅仅是一个开始，每次下榻时您将获享各种灵活礼遇，量身定制的个性化体验及惊喜时刻。'],
    image: fan, alt: 'Woman holding a colored fan in front of her face.',
    benefitsTitle: '尚扇荟 (Fans of M.O.) 礼遇',
    benefitsDescription: ['尚扇荟尚扇会员每次下榻酒店时，可获享一系列专属礼遇，此类礼遇符合您的需求并将随着您与我们的互动而不断丰富。无论入住哪家酒店，均可获赠当地特色迎宾礼品。如向我们直接预订，可在此次入住时享受多达两项额外的尚扇荟礼遇。'],
    included: [welcomeGift],
    optional: [
      {
        id: 'breakfast', name: '单人每日早餐', image: breakfast,
        alt: 'Breakfast including a croissant and egg on a tray.',
        description: '享用赠送的新鲜营养早餐，开启美好一天。'
      },
      earlyCheckIn, lateCheckOut, diningCredit(50), celebratoryTreat,
      {
        id: 'second-breakfast', name: '第二位宾客每日早餐', image: breakfastForTwo,
        alt: 'Breakfast pastries and tea on a table.',
        description: '随行宾客额外免费早餐。'
      }
    ],
    partnerTitle: '您的尚扇荟尚扇会员礼遇始终适用',
    partnerDescription: '贵为尚扇荟尚扇会员，您可发现和享受我们的精选合作伙伴提供的各种专属礼遇、独特体验和特殊优惠。'
  },
  {
    id: 'silk', label: '缎扇会员', name: '尚扇荟缎扇会员',
    introduction: [
      '尚扇荟缎扇会员社群面向更常莅临我们酒店、餐厅和水疗中心的尊贵会员。',
      '尚扇荟缎扇会员可享受额外礼遇，包括双人每日早餐、客房升级以及更高价值的签账额。',
      '此外，缎扇会员每次莅临下榻文华东方时，均可尊享其他丰富活动，包括定制化的水疗护理升级，以及由专业厨师奉上的免费美食佳肴。'
    ],
    image: silk, alt: 'Woman holding a blue silk fan.',
    benefitsTitle: '尚扇荟 (Fans of M.O.) 缎扇会员专享礼遇',
    benefitsDescription: [
      '尚扇荟缎扇会员每次下榻酒店时，可获享更多专属礼遇，此类礼遇贴合您的需求并将随着您与我们的互动而不断丰富。无论入住哪家酒店，均可获赠当地特色迎宾礼品。',
      '如从文华东方直接预订，可享受双人每日早餐以及两项额外的尚扇荟礼遇。'
    ],
    included: [welcomeGift, {
      id: 'double-breakfast', name: '每日双人早餐', image: breakfastForTwo,
      alt: 'Breakfast pastries and tea on a table.',
      description: '如直接预订，可免费享用新鲜营养的双人早餐，开启美好一天。'
    }],
    optional: [earlyCheckIn, lateCheckOut, diningCredit(100), celebratoryTreat, {
      id: 'upgrade', name: '客房升级*', image: upgrade,
      alt: 'Entrance to a suite with flowers on a table.',
      description: '欢迎下榻我们的优雅客房或套房，尊享奢华体验。'
    }],
    partnerTitle: '您的尚扇荟缎扇会员礼遇始终适用',
    partnerDescription: '贵为尚扇荟 (Fans of M.O.) 缎扇会员，您可解锁一系列我们的精选合作伙伴提供的专属礼遇、独特体验和特殊优惠。'
  },
  {
    id: 'pearl', label: '珠扇会员', name: '尚扇荟珠扇会员',
    introduction: ['仅限受邀人士。'],
    image: pearl, alt: 'Woman holding a fan in front of her face.'
  }
];
